import helpers from "../../shared/fleetbox-helpers";
import { Marker, GeoPosition } from "../../domain/poi";
import { mapGetters } from "vuex";
import { bus } from "../../main";

export default {
	components: {},
	props: {
		data: Array,
		mapCenterLocation: {
			type: Object,
			default: {
				lat: 0,
				lng: 0
			}
		},
		zoom: {
			type: Number,
			default: 12
		}
	},
	data: function() {
		return {
			firstTimeIn: true,
			center: {},
			markers: [],
			infoContent: "",
			infoWindowPos: null,
			infoWinOpen: false,
			currentMidx: null,
			infoOptions: {
				content: "",
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			paths: [],
			areas: [],
			loading: true,

			viewSatellite: false,
			mapStylesOptions: [ 
				{
					featureType: "poi",
					stylers: [ 
						{ 
							visibility: "off" 
						} 
					] 
				} 
			]
		};
	},
	watch: {},
	created() {
		var self = this;

		if (this.settings) {
			if (this.settings.viewSatellite) this.viewSatellite = this.settings.viewSatellite;
		}

		self.center = {
			lat: self.mapCenterLocation.lat,
			lng: self.mapCenterLocation.lng
		};

		// self.$gmapApiPromiseLazy().then(() => {
		// 	self.$watch("data", function(newValue, oldValue) {
		// 		if (self.markersShown && self.markersShown.length > 0 && newValue) {
		// 			let markersToRemove = self._.differenceBy(self.markersShown, newValue, "id");
		// 			self.removeMarkers(markersToRemove);
		// 		}

		// 		if (newValue.length != self.markersShown.length) self.displayMarkers();
		// 		self.markersShown = self._.clone(newValue);
		// 	});
		// });
		// bus.$on("on-show-geofence-poi", this.onShowGeofencePoi.bind(this));
		// bus.$on("on-hide-geofence-poi", this.onHideGeofencePoi.bind(this));
	},
	mounted() {
		var self = this;
		setTimeout(function() {
			self.displayMarkers();
		}, 1);
	},
	beforeDestroy() {
		// bus.$off("on-show-geofence-poi");
		// bus.$off("on-hide-geofence-poi");
	},
	/* metodi */
	methods: {
		mapTilesloaded() {
			console.log("tilesloaded fired");
			this.loading = false;
		},
		markerOut() {
			helpers.deleteTooltip();
		},
		markerOver($event, m) {
			helpers.injectTooltip($event.tb, m.description);
		},
		removeMarkers: function(markersToRemove) {
			var self = this;
			if (markersToRemove && markersToRemove.length > 0) {
				var idsToRemove = markersToRemove.map(function(x) {
					return x.id;
				});

				for (let i = 0; i < idsToRemove.length; i++) {
					let id = idsToRemove[i];
					let index = self.markers.findIndex(function(a) {
						return a.id == id;
					});

					if (index >= 0) {
						self.markers.splice(index, 1);
					}
					// self._.remove(self.markers, function(item) {
					// 	return item.id == id;
					// });
				}

				if (self.markers.length === 0) {
					self.markers = [];
				}
			}
		},
		displayMarkers: function() {
			var self = this;

			//items to remove - marker
			// var itemsToRemove = [];
			// for (let i = 0; i < this.markers.length; i++) {
			// 	var m = this.markers[i];
			// 	let dataItem = _.find(this.data, d => {
			// 		return d.id == m.id;
			// 	});

			// 	if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			// }

			// itemsToRemove.forEach(r => {
			// 	let index = self.markers.findIndex(function(o) {
			// 		return o.id == r;
			// 	});

			// 	self.markers.splice(index, 1);
			// });

			// //items to remove - polygon
			// itemsToRemove = [];
			// for (let i = 0; i < this.paths.length; i++) {
			// 	var m = this.paths[i];
			// 	let dataItem = _.find(this.data, d => {
			// 		return d.id == m.id;
			// 	});

			// 	if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			// }

			// itemsToRemove.forEach(r => {
			// 	let index = self.paths.findIndex(function(o) {
			// 		return o.id == r;
			// 	});

			// 	self.paths.splice(index, 1);
			// });

			// //items to remove - area
			// itemsToRemove = [];
			// for (let i = 0; i < this.areas.length; i++) {
			// 	var m = this.areas[i];
			// 	let dataItem = _.find(this.data, d => {
			// 		return d.id == m.id;
			// 	});

			// 	if (!dataItem || dataItem.visible == false) itemsToRemove.push(m.id);
			// }

			// itemsToRemove.forEach(r => {
			// 	let index = self.areas.findIndex(function(o) {
			// 		return o.id == r;
			// 	});

			// 	self.areas.splice(index, 1);
			// });

			// var forceFitAndZoom = false;
			var minZoomValue = null;

			self.data.forEach(function(item, index) {
				if (item.location.rendering_type == "marker" || (item.location.rendering_type == "unknown" && item.location.points.length == 1)) {
					let m = _.find(self.markers, function(o) {
						return o.id == item.id;
					});

					if (m == null) {
						m = new google.maps.Marker();
						m.id = item.id;
						m.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: -40
							}
						};

						// google.maps.event.addListener(m, 'dragend', function(evt){
						// 	self.onMarkerDraged(evt);
						// });

						self.markers.push(m);
					}

					m.draggable = item.draggable;
					m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
					m.title = item.name;
					//m.info = "<b>" + item.name + "</b><br/>lat: " + item.location.points[0].lat + " lon: " + item.location.points[0].lon;
					m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
					if (item.poi_category_icon_image && !self.isInEditMode) {
						var icon = {
							url: item.poi_category_icon_image,
							scaledSize: new google.maps.Size(30, 36), // scaled size
							origin: new google.maps.Point(0, 0) // origin
						};
						m.icon = icon;
					}
					m.infoWindowOptions.content = m.info;
				} else if (item.location.rendering_type == "polygon" || (item.location.rendering_type == "unknown" && item.location.points.length > 1)) {
					//marker related to polygon
					var allPoint = "";
					item.location.points.forEach(function(point) {
						allPoint += `lat: ${point.lat} - lon:${point.lon}<br />`;
					});
					if (!self.isInEditMode) {
						let m = _.find(self.markers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.markers.push(m);
						}

						m.draggable = false;
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.title = item.name;
						// m.info = `<b>${item.name}</b><br />${allPoint}`;
						m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
						if (item.poi_category_icon_image) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					}

					//polygon
					let p = _.find(self.paths, function(o) {
						return o.id == item.id;
					});

					if (p == null) {
						p = {
							id: item.id,
							// path: item.location.points.map(function(pt) {
							// 	return new GeoPosition(pt.lat, pt.lon);
							// }),
							infoWindowOptions: {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: 0
								}
							}
						};

						self.paths.push(p);
					}
					if (!self.isInEditMode) {
						p.fillColor = item.poi_category_fill_color;
					}
					p.editable = item.editable;
					p.draggable = item.draggable;
					// var allPoint = "";
					// item.location.points.forEach(function(point) {
					// 	allPoint += `lat: ${point.lat} - lon:${point.lon}<br />`;
					// });
					(p.path = item.location.points.map(function(pt) {
						return new GeoPosition(pt.lat, pt.lon);
					})),
						(p.title = item.name);
					p.info = `<b>${item.name}</b><br />
									LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									INDIRIZZO: ${item.location.address}<br />`;
					p.infoWindowOptions.content = p.info;
				} else if (item.location.rendering_type == "circle") {
					//marker related to circle
					if (!self.isInEditMode) {
						let m = _.find(self.markers, function(o) {
							return o.id == item.id;
						});

						if (m == null) {
							m = new google.maps.Marker();
							m.id = item.id;
							m.infoWindowOptions = {
								infoWindowOpened: false,
								pixelOffset: {
									width: 0,
									height: -40
								}
							};

							self.markers.push(m);
						}

						m.draggable = item.draggable;
						m.position = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);
						m.title = item.name;
						//m.info = "<b>" + item.name + "</b><br/>lat: " + item.location.points[0].lat + " lon: " + item.location.points[0].lon;
						m.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address || ""}<br />`;
						if (item.poi_category_icon_image) {
							var icon = {
								url: item.poi_category_icon_image,
								scaledSize: new google.maps.Size(30, 36), // scaled size
								origin: new google.maps.Point(0, 0) // origin
							};
							m.icon = icon;
						}
						m.infoWindowOptions.content = m.info;
					}
					//area
					let a = _.find(self.areas, function(o) {
						return o.id == item.id;
					});

					if (a == null) {
						a = new google.maps.Circle();
						a.id = item.id;
						a.radius = item.radius;
						a.infoWindowOptions = {
							infoWindowOpened: false,
							pixelOffset: {
								width: 0,
								height: 0
							}
						};

						self.areas.push(a);

						minZoomValue = 16;
					}
					if (!self.isInEditMode) {
						a.fillColor = item.poi_category_fill_color;
					}
					a.center = new GeoPosition(item.location.points[0].lat, item.location.points[0].lon);

					(a.editable = item.editable), (a.draggable = item.draggable), (a.title = item.name);
					a.info = `<b>${item.name}</b><br />
									  LAT: ${item.location.points[0].lat} - LON: ${item.location.points[0].lon}<br />
									  INDIRIZZO: ${item.location.address}<br />`;
					a.infoWindowOptions.content = a.info;
				}
			});

			self.fitAndZoom(minZoomValue);

			setTimeout(function() {
				self.loading = false;
			}, 4000);
		},

		setCustomZoom(value) {
			var self = this;
			if (self.$refs.geofencemap) {
				self.$refs.geofencemap.$mapPromise.then(map => {
					map.setZoom(value);
				});
			}
		},
		fitAndZoom: function(minZoomValue) {
			var self = this;

			var bounds = new google.maps.LatLngBounds();

			if (self.markers.length > 0 || self.paths.length > 0 || self.areas.length > 0) {
				self.areas.forEach(function(item, index) {
					let circle = new google.maps.Circle({
						center: item.center,
						radius: item.radius
					});
					bounds.union(circle.getBounds());
				});

				self.markers.forEach(function(item, index) {
					bounds.extend(item.position);
				});

				self.paths.forEach(function(item, index) {
					item.path.forEach(p => {
						bounds.extend(p);
					});
				});

				setTimeout(function() {
					self.$refs.geofencemap.$mapPromise.then(map => {
						map.fitBounds(bounds);

						if (map.getZoom() >= 22) {
							if (minZoomValue) map.setZoom(minZoomValue);
							else map.setZoom(14);
						}
					});
				}, 1);
			} else {
				this.centerMap({
					lat: 46.07339415289572,
					lng: 13.22305560185896
				});
			}
		},
		markerClick: function(marker, idx) {
			this.hideAllInfoWindow();

			this.toggleInfoWindow(marker);
		},
		hideAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.paths.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});

			self.areas.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = false;
			});
		},
		showAllInfoWindow: function() {
			var self = this;

			self.markers.forEach(function(item, index) {
				item.infoWindowOptions.infoWindowOpened = true;
			});
		},
		centerMap: function(position) {
			var self = this;

			self.$refs.geofencemap.$mapPromise.then(map => {
				map.setCenter(position);
			});
		},
		toggleInfoWindow: function(marker, idx) {
			marker.infoWindowOptions.infoWindowOpened = !marker.infoWindowOptions.infoWindowOpened;
		},
		drawRect: function(point, r1, r2, r3, r4, rotation, vertexCount, strokeColour, strokeWeight, Strokepacity, fillColour, fillOpacity, opts, tilt) {
			var rot = (-rotation * Math.PI) / 180;
			var points = [];
			var latConv = google.maps.geometry.spherical.computeDistanceBetween(point, new google.maps.LatLng(point.lat() + 0.1, point.lng())) * 10;
			var lngConv = google.maps.geometry.spherical.computeDistanceBetween(point, new google.maps.LatLng(point.lat(), point.lng() + 0.1)) * 10;
			var step = 360 / vertexCount || 10;

			var flop = -1;
			if (tilt) {
				var I1 = 180 / vertexCount;
			} else {
				var I1 = 0;
			}
			for (var i = I1; i <= 360.001 + I1; i += step) {
				var r1a = flop ? r1 : r3;
				var r2a = flop ? r2 : r4;
				flop = -1 - flop;
				var y = r1a * Math.cos((i * Math.PI) / 180);
				var x = r2a * Math.sin((i * Math.PI) / 180);
				var lng = (x * Math.cos(rot) - y * Math.sin(rot)) / lngConv;
				var lat = (y * Math.cos(rot) + x * Math.sin(rot)) / latConv;

				points.push(new google.maps.LatLng(point.lat() + lat, point.lng() + lng));
			}
			return new google.maps.Polygon({
				paths: points,
				strokeColor: strokeColour,
				strokeWeight: strokeWeight,
				strokeOpacity: Strokepacity,
				fillColor: fillColour,
				fillOpacity: fillOpacity
			});
		}
	},
	computed: {
		...mapGetters(["settings"])
	}
};
